import React, { memo } from 'react'

type BoxType = {
  children: React.ReactNode
  patent?: boolean
  thumnail?: boolean
}

export const BoxService: React.FC<BoxType> = memo(
  ({ children, patent = false, thumnail = false }) => {
    return (
      <div className="relative rounded-lg w-full md:max-w-[47%] lg:max-w-[29%]">
        {patent && (
          <img
            src="/images/img_icon_patent.png"
            className="absolute top-[-0.5rem] left-[-0.5rem] w-full h-auto"
            alt="特許技術"
          />
        )}
        {children}
      </div>
    )
  }
)

BoxService.displayName = 'BoxService'
